import PropTypes from 'prop-types'

import { useStyletron } from 'baseui'
import Icon from 'baseui/icon/icon'

const IconWarning = ({ color, overrides, ref, size, title }) => {
  const [, theme] = useStyletron()

  title = title ?? 'Warning alt'
  size = size ?? 16
  color = color ?? theme.colors.primary

  return (
    <Icon ref={ref} viewBox='0 0 24 24' size={size} color={color} overrides={overrides}>
      <title>{title}</title>
      <path d='M12.001 3C12.1677 3 12.3307 3.04168 12.4893 3.125C12.6473 3.20831 12.776 3.33341 12.876 3.5L22.126 19.5C22.226 19.6666 22.2726 19.8372 22.2647 20.0117C22.256 20.1871 22.2094 20.35 22.126 20.5C22.0427 20.6499 21.9264 20.7713 21.7764 20.8633C21.6265 20.9546 21.4597 21 21.2764 21H2.72661C2.5434 21 2.37653 20.9545 2.22661 20.8633C2.07661 20.7713 1.95936 20.65 1.87603 20.5C1.79274 20.35 1.74731 20.187 1.73931 20.0117C1.73071 19.8372 1.77614 19.6665 1.87603 19.5L11.126 3.5C11.226 3.33333 11.3557 3.20833 11.5137 3.125C11.6722 3.04182 11.8346 3.00006 12.001 3ZM4.45122 19H19.5518L12.001 6L4.45122 19ZM12.001 16C12.2843 16 12.5219 16.0962 12.7139 16.2881C12.9053 16.4794 13.001 16.7167 13.001 17C13.001 17.2833 12.9053 17.5206 12.7139 17.7119C12.5219 17.9038 12.2843 18 12.001 18C11.7178 17.9999 11.4804 17.9038 11.2891 17.7119C11.0972 17.5206 11.001 17.2832 11.001 17C11.001 16.7168 11.0972 16.4794 11.2891 16.2881C11.4804 16.0962 11.7178 16.0001 12.001 16ZM12.001 10C12.2843 10 12.5219 10.0959 12.7139 10.2871C12.9053 10.4791 13.001 10.7167 13.001 11V14C13.001 14.2833 12.9053 14.5206 12.7139 14.7119C12.5219 14.9038 12.2843 15 12.001 15C11.7178 14.9999 11.4804 14.9038 11.2891 14.7119C11.0972 14.5206 11.001 14.2832 11.001 14V11C11.001 10.7168 11.0972 10.4791 11.2891 10.2871C11.4804 10.0959 11.7178 10.0001 12.001 10ZM24.751 0H23.751V-1H24.751V0Z' />
    </Icon>
  )
}

IconWarning.propTypes = {
  color: PropTypes.string,
  overrides: PropTypes.object,
  ref: PropTypes.object,
  size: PropTypes.number,
  title: PropTypes.string,
}

export default IconWarning
